function alignGridArticleTitles() {
	const grids = document.querySelectorAll('.iso-posts-grid, .is-layout-grid');

	if (!grids.length || window.innerWidth < 768) {
		// Reset si mobile ou pas de grilles
		document.querySelectorAll('.iso-card-testimonial-title').forEach(title => {
			title.style.height = 'auto';
		});
		return;
	}

	grids.forEach(grid => {
		const titles = grid.querySelectorAll('.iso-card-testimonial-title');
		if (!titles.length) return;

		// Reset pour mesurer correctement
		titles.forEach(title => (title.style.height = 'auto'));

		let columns = 1;

		// --- Cas 1 : posts-grid avec class iso-posts-grid--cols-X ---
		const match = grid.className.match(/iso-posts-grid--cols-(\d+)/);
		if (match) {
			columns = parseInt(match[1], 10);
		} else if (grid.classList.contains('is-layout-grid')) {
			// --- Cas 2 : grille Gutenberg native ---
			const gridStyle = getComputedStyle(grid);
			const template = gridStyle.gridTemplateColumns;
			if (template) {
				// On compte le nombre de colonnes définies
				columns = template.split(' ').length;
			}
		}

		// --- Alignement ligne par ligne ---
		for (let i = 0; i < titles.length; i += columns) {
			const rowTitles = Array.from(titles).slice(i, i + columns);

			let maxHeight = 0;
			rowTitles.forEach(title => {
				const h = title.offsetHeight;
				if (h > maxHeight) maxHeight = h;
			});

			rowTitles.forEach(title => {
				title.style.height = `${maxHeight}px`;
			});
		}
	});
}

// Initialisation
document.addEventListener('DOMContentLoaded', () => {
	alignGridArticleTitles();
});

// Réapplique au resize
window.addEventListener('resize', () => {
	requestAnimationFrame(() => alignGridArticleTitles());
});
